import { init as initSelect } from "../../../components/uic-select";

export function initSearchSelect(element, { dispatch }) {
    if (!element) {
        return;
    }

    const requests = {};
    const action = element.dataset.action;
    const token = element.dataset.token;
    const field = element.dataset.field;
    const select = initSelect(element);

    select.input.addEventListener("input", () => {
        if (!(select.input.value in requests)) {
            requests[select.input.value] = true;

            const body = new FormData();

            body.append("token", token);
            body.append(field, select.input.value);

            select.filter();

            fetch(action, {
                method: "POST",
                body: body
            }).then(res => res.json())
            .then((response) => {
                dispatch(select, response);
                select.filter();
            });
        }
        else {
            select.filter();
        }
    });

    return select;
}
